import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ onPrev, monthNames, month, year, onNext }) => (
  <div className="r-row r-head">
    <div
      className="r-cell r-prev"
      onClick={() => onPrev()}
      role="button"
      tabIndex="0"
    />
    <div className="r-cell r-title">{`${monthNames[month]}  ${year}`}</div>
    <div
      className="r-cell r-next"
      onClick={() => onNext()}
      role="button"
      tabIndex="0"
    />
  </div>
);

Header.propTypes = {
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  monthNames: PropTypes.array,
  month: PropTypes.number,
  year: PropTypes.number,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Calendar/Header.js